import React, { useState, useEffect } from 'react';
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil';
import { siteUrl } from '../../../shared/utils/siteUrl'
import './card-article.scss'

const CardArticle = props => {

  // const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  // const getDate = (date) => {
  //     var dateForm = new Date(date)
  //     return dateForm.getDate() + " de " + monthNames[dateForm.getMonth()] //+ " de " + dateForm.getFullYear()
  // }
  var homeLink = siteUrl + '/'

  const [link, setLink] = useState('');

  useEffect(() => {
    var link = ""
    switch (props.item.contentType) {
      case "articulos":
        if (props.item.seccionDelArticulo === "Nuestro Mundo") {
          link = "magazin/nuestro-mundo/" + props.item.slug
        } else {
          link = "entre-nosotras/" + props.item.slug
        }

        break;
      case "nolProductos":
        link = "productos/" + props.item.referenciaSubcategoria.categoria + "/" + props.item.referenciaSubcategoria.slug + "/" + props.item.slug
        break;
      case "nolSignosDelHoroscopo":
        link = "magazin/horoscopo/" + props.item.slug
        break;
      case "nolConsultorios":
        link = "entre-nosotras/consultorios/" + props.item.slug
        break;
      case "nolJuegos":
        link = "magazin/juegos/" + props.item.slug
        break;
      case "nolConcursos":
        link = "magazin/concursos/" + props.item.slug
        break;

      default:
        break;
    }
    setLink(link)

  }, [])

  
  const dataLayerCardArticle = () => {
    pushDataLayerEvent({
      event: "gaEvent",
      eventTrigger: 'articleClick',
      eventCategory: 'Article Click',
      eventAction: props.item.metaTitulo, //this have to be dynamically pushed.
      eventLabel: siteUrl+'/buscador', //this have to be dynamically pushed.
      eventValue: undefined,
    })
    pushDataLayerEvent({
      event: "select_search_result",
      search_term: props.valueSerched,
      search_results_count: props.resultSize,
      index: props.index
    })
  }

  return (
    <>
      {props.item !== [] &&
        <a href={homeLink + link} className={"f-card"} onClick={() => {
          dataLayerCardArticle()
        }}>
          <div className="f-card-imgarticle" >
            <img

              alt={props.item.metaImagen.description}
              src={props.item.metaImagen.file.url}

            />
          </div>
          <div className="f-card-info ">
            <h3>{props.item.metaTitulo}</h3>

            <p className="f-card-info-description">{props.item.metaDescripcion.metaDescripcion.split("\n")[0]}</p>
          </div>
        </a>
      }
    </>
  )
}

export default CardArticle
